"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var sectionHeaderDefaults = {
  bgColorPrimary: 'transparent',
  bgColorSecondary: 'secondary',
  buttonMarginTop: 'xlarge',
  columnWidth: [12, null, 10],
  componentPadding: 'xxlarge',
  buttonFlexWrap: 'nowrap'
};
var sectionHeader = {
  horizon: _objectSpread({}, sectionHeaderDefaults),
  lionsLive: _objectSpread(_objectSpread({}, sectionHeaderDefaults), {}, {
    bgColorSecondary: 'accent1'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, sectionHeaderDefaults), {}, {
    columnWidth: [12, null, 12],
    componentPadding: 'base',
    buttonFlexWrap: 'wrap'
  }),
  dcl: _objectSpread(_objectSpread({}, sectionHeaderDefaults), {}, {
    columnWidth: [12, null, 12]
  }),
  money2020: {
    buttonFlexWrap: 'wrap'
  }
};
var _default = sectionHeader;
exports.default = _default;